import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  FormControl,
  FormArray,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { UserRegistrationService } from '../../shared/service/user-registration.service';
import { CompanyService } from '../../shared/service/company.service';
import { ToastrService } from 'ngx-toastr';
import { SyncToStgService } from 'src/app/shared/service/sync-to-stg.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit, OnDestroy {
  companies: any;
  companies_stg2: any = []; // STG2環境用
  needSync: boolean;
  isSTG: boolean;

  freezeUser = new FormControl(-1);
  company_selected = '';
  userList = [];
  // setup form
  // one company can have multiple users(FormArray)
  newUserForm = this.fb.group({
    company_id: ['', Validators.required],
    company_stg_id: ['0', Validators.required],

    company_detail: this.fb.group({
      name: [''],
      company_code: [''],
      mail_domain: [''],
      representative_mail_account: ['']
    }),

    users: this.fb.array([this.NewUser()])
  });

  private companyListSubscription: Subscription;
  private companyStgListSubscription: Subscription;
  private companyIdValueChangesSubscription: Subscription;
  private userListSubscription: Subscription;
  private freezeUserSubscription: Subscription;

  get users() {
    return this.newUserForm.get('users') as FormArray;
  }
  get company_id() {
    return this.newUserForm.get('company_id') as FormControl;
  }

  get company_detail() {
    return this.newUserForm.get('company_detail') as FormGroup;
  }

  get company_stg_id() {
    return this.newUserForm.get('company_stg_id') as FormControl;
  }

  ngOnInit() {
    this.isSTG = this.syncToStgService.needSync();
    this.needSync = this.syncToStgService.needSync();
    this.getCompanyList().then(() => {
      this.loadUsers();
      this.companyIdValueChangesSubscription = this.company_id.valueChanges.subscribe(val => this.companySelectChange());
    }).catch(err => {
      console.error('Error loading company list', err);
    });
  }

  ngOnDestroy() {
    if (this.companyListSubscription) {
      this.companyListSubscription.unsubscribe();
    }
    if (this.companyStgListSubscription) {
      this.companyStgListSubscription.unsubscribe();
    }
    if (this.companyIdValueChangesSubscription) {
      this.companyIdValueChangesSubscription.unsubscribe();
    }
    if (this.userListSubscription) {
      this.userListSubscription.unsubscribe();
    }
    if (this.freezeUserSubscription) {
      this.freezeUserSubscription.unsubscribe();
    }
  }

  constructor(
    private fb: FormBuilder,
    private userRegistrationService: UserRegistrationService,
    private companyService: CompanyService,
    private toastrService: ToastrService,
    private syncToStgService: SyncToStgService
  ) {}

  NewUser() {
    return this.fb.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      user_code: ['', Validators.required],
      auth: [2, Validators.required],
      password: ['Abcd1234', Validators.required],
      password_confirm: ['Abcd1234', Validators.required],
      gross_margin_setting: ['5', Validators.required]
    });
  }

  getCompanyList(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.companyListSubscription = this.companyService.getCompanyList().subscribe({
        next: res => {
          this.companies = res.body;
          this.companies.unshift({ company_code: 'not exist', id: '-1' });
          this.company_id.setValue(this.companies[0].id);
          resolve();
        },
        error: err => {
          this.toastrService.warning("Can't get company list!");
          console.warn("Can't get company list!");
          console.warn(err);
          reject(err);
        }
      });

      if (this.isSTG && this.needSync) {
        this.companyStgListSubscription = this.syncToStgService.getCompanyList().subscribe({
          next: res => {
            this.companies_stg2 = res.body;
            this.companies_stg2.unshift({ company_code: 'not exist', id: '-1' });
            this.company_stg_id.setValue(this.companies_stg2[0].id);
            resolve();
          },
          error: err => {
            this.toastrService.warning("STG2_Can't get company list!");
            console.warn("STG2_Can't get company list!");
            console.warn(err);
            reject(err);
          }
        });
      }
    });
  }

  addNewUser() {
    this.users.push(this.NewUser());
  }
  deleteUser(num: number) {
    this.users.removeAt(num);
  }

  companySelectChange() {
    const companySelected = this.companies.find(
      company => String(company.id) === this.company_id.value
    );
    if (companySelected) {
      const companyStg2Selected = this.companies_stg2.find(
        company_stg2 => company_stg2.company_code === companySelected.company_code
      );
      if (companyStg2Selected) {
        this.company_stg_id.setValue(companyStg2Selected.id);
      } else {
        this.company_stg_id.setValue('-1');
      }
    }
  }

  onSubmit() {
    this.userRegistrationService.createNewUsers(this.newUserForm.value);
    if (this.isSTG && this.needSync) {
      this.userRegistrationService.createNewUsers(
        this.newUserForm.value,
        '_STG2'
      );
    }
  }
  loadUsers() {
    this.userListSubscription = this.userRegistrationService.getUserList().subscribe(res => {
      this.userList = res.body;
    });
  }
  freeze() {
    this.freezeUserSubscription = this.userRegistrationService
      .freezeUser(this.freezeUser.value)
      .subscribe(res => {
        this.userList = res.body;
        this.freezeUser.reset();
        this.toastrService.success('freeze switch success');
      });
  }
}
